/*Sage Custom Code Start (Oct 2025)*/
/* created wishlist javascript file*/


(function () {
  if (window.__VSL_WISHLIST_FINAL_V4) return;
  window.__VSL_WISHLIST_FINAL_V4 = true;

  const KEY = "vsl_wishlist_v1";
  const MERGED_KEY = "vsl_wishlist_merged";
  const LOADED_KEY = "vsl_wishlist_loaded";
  const BTN_SELECTOR = ".wishlist-product-heart, .product-card-wishlist";
  const COUNT_SELECTOR = ".header-actions__action .wishlist-count";
  const CUSTOMER_ID = window.shopifyCustomerId || "";

  const getWishlist = () => {
  try {
    const list = JSON.parse(localStorage.getItem(KEY)) || [];

    const unique = [];

    list.forEach((item) => {
      const identity = item.variantId
        ? `variant:${item.variantId}`
        : `product:${item.id}`;

      const exists = unique.some(existing => {
        const existingIdentity = existing.variantId
          ? `variant:${existing.variantId}`
          : `product:${existing.id}`;

        return existingIdentity === identity;
      });

      if (!exists) {
        unique.push(item);
      }
    });

    return unique;
  } catch {
    return [];
  }
};

 const saveWishlist = (arr) => {
  localStorage.setItem(KEY, JSON.stringify(arr));

  updateCount();

  syncWishlistToSupabase(arr).catch(console.error);
};

async function syncWishlistToSupabase(wishlist) {

  if (!CUSTOMER_ID) return;

  // Remove old wishlist
  await supabaseClient
    .from('wishlists')
    .delete()
    .eq('customer_id', CUSTOMER_ID);

  // Stop if empty
  if (!wishlist.length) return;

  // Prepare rows
  const rows = wishlist.map(item => ({
  customer_id: CUSTOMER_ID,
  product_id: item.id || '',
  variant_id: item.variantId || '',
  title: item.title || '',
  handle: item.handle || '',
  price: item.price || '',
  image: item.image || '',
  variant_title: item.variantTitle || '',
  variant_available: item.variantAvailable ?? true
}));

  // Upload new wishlist
  const { error } = await supabaseClient
    .from('wishlists')
    .insert(rows);

  if (error) {
    console.error('Supabase sync error:', error);
  } else {
    console.log('Wishlist synced');
  }
}

async function loadWishlistFromSupabase() {

  if (!CUSTOMER_ID) return;

  const { data, error } = await supabaseClient
    .from('wishlists')
    .select('*')
    .eq('customer_id', CUSTOMER_ID);

  if (error) {
    console.error('Load wishlist error:', error);
    return;
  }

  if (!data) return;

  const formatted = data.map(item => ({
  handle: item.handle,
  id: item.product_id,
  title: item.title,
  image: item.image,
  variantId: item.variant_id,
  variantTitle: item.variant_title,
  variantAvailable: item.variant_available
}));

  const alreadyMerged =
  localStorage.getItem(MERGED_KEY);

if (!alreadyMerged) {

  const localWishlist = getWishlist();

  const merged = [...formatted];

  localWishlist.forEach(item => {

    const exists = merged.some(
      p => String(p.variantId) === String(item.variantId)
    );

    if (!exists) {
      merged.push(item);
    }
  });

  localStorage.setItem(
    KEY,
    JSON.stringify(merged)
  );

  localStorage.setItem(MERGED_KEY, "true");

  syncWishlistToSupabase(merged)
    .catch(console.error);

} else {

  localStorage.setItem(
    KEY,
    JSON.stringify(formatted)
  );
}

  updateCount();
  syncButtons();

  document.dispatchEvent(
    new Event("vsl:render-wishlist")
  );

  console.log('Wishlist loaded from Supabase');
}

  // 🧩 Update persistent header count (your existing styled badge)
  function updateCount() {
    const el = document.querySelector(COUNT_SELECTOR);
    const count = getWishlist().length;

    if (el) {
      el.textContent = count;
      el.style.display = count > 0 ? "inline-flex" : "none";
    }

    // Notify theme.liquid script (for ::after badge update)
    window.dispatchEvent(new Event("wishlist:updated"));
  }

  function syncButtons() {
  const wishlist = getWishlist();

  document.querySelectorAll(BTN_SELECTOR).forEach((btn) => {

    const rawProductId = btn.dataset.productId;

    if (!rawProductId) {
      return;
    }

    const productId = String(rawProductId);

    const isActive =
      wishlist.some(
        item =>
          String(item.id) === productId
      );

    btn.setAttribute(
      'aria-pressed',
      isActive ? 'true' : 'false'
    );

    btn.classList.toggle(
      'is-active',
      isActive
    );

    btn.classList.toggle(
      'active',
      isActive
    );

    btn.dataset.wishlistActive =
      isActive ? 'true' : 'false';
  });
}

  document.addEventListener("click", async (e) => {
  const btn = e.target.closest(BTN_SELECTOR);
  if (!btn) return;

  e.preventDefault();

  const productId = btn.dataset.productId;
  const handle = btn.dataset.productHandle;

  if (!productId || !handle) return;

  await openWishlistModal(btn);
});

  // 🧩 Initialize

  async function init() {

  const alreadyLoaded =
    sessionStorage.getItem(LOADED_KEY);

  if (!alreadyLoaded) {

    await loadWishlistFromSupabase();

    sessionStorage.setItem(
      LOADED_KEY,
      "true"
    );
  }

  updateCount();
  syncButtons();
}

let wishlistProductCache = new Map();

function getCurrentVariant(btn) {

  /*
   * --------------------------------------------------
   * FIND THE PRODUCT-PAGE VARIANT PICKER
   * --------------------------------------------------
   */

  let picker = null;

  if (btn) {
    picker = btn
      .closest(
        'product-information, product-info, product-card, quick-add-component'
      )
      ?.querySelector('variant-picker');
  }

  /*
   * Main product page fallback.
   */
  if (!picker) {
    picker = document.querySelector(
      'product-information variant-picker, ' +
      'product-info variant-picker'
    );
  }

  /*
   * Final fallback.
   */
  if (!picker) {
    picker = document.querySelector('variant-picker');
  }

  if (!picker) {
    return null;
  }

  /*
   * --------------------------------------------------
   * 1. THEME CURRENT VARIANT
   * --------------------------------------------------
   */

  if (picker.currentVariant?.id) {
    return String(picker.currentVariant.id);
  }

  /*
   * Some themes expose the variant through a property
   * on the picker.
   */
  if (picker.selectedVariant?.id) {
    return String(picker.selectedVariant.id);
  }

  /*
   * --------------------------------------------------
   * 2. PRODUCT FORM HIDDEN VARIANT ID
   * --------------------------------------------------
   */

  const form =
    picker.closest('form') ||
    document.querySelector(
      'product-information form[action*="/cart/add"], ' +
      'form[action*="/cart/add"]'
    );

  const variantInput =
    form?.querySelector('input[name="id"]') ||
    picker.querySelector('input[name="id"]');

  if (variantInput?.value) {
    return String(variantInput.value);
  }

  /*
   * --------------------------------------------------
   * 3. SELECTED INPUT WITH VARIANT ID
   * --------------------------------------------------
   */

  const checkedInputs =
    picker.querySelectorAll(
      'input[type="radio"]:checked, ' +
      'fieldset input:checked'
    );

  for (const input of checkedInputs) {

    if (input.dataset.variantId) {
      return String(input.dataset.variantId);
    }

    if (input.getAttribute('data-variant-id')) {
      return String(
        input.getAttribute('data-variant-id')
      );
    }
  }

  /*
   * --------------------------------------------------
   * 4. SELECT OPTION WITH VARIANT ID
   * --------------------------------------------------
   */

  const selects =
    picker.querySelectorAll('select');

  for (const select of selects) {

    const option =
      select.options?.[select.selectedIndex];

    if (
      option?.dataset?.variantId
    ) {
      return String(
        option.dataset.variantId
      );
    }

    if (
      option?.getAttribute('data-variant-id')
    ) {
      return String(
        option.getAttribute('data-variant-id')
      );
    }
  }

  /*
   * --------------------------------------------------
   * 5. FINAL FALLBACK
   *
   * Read the currently selected option values.
   *
   * This is important for the Aluovi product page
   * because the color can already be selected even
   * when the theme has not exposed the final variant
   * ID yet.
   * --------------------------------------------------
   *
   * We return the values themselves through a temporary
   * property so the wishlist modal can resolve the
   * correct product variant.
   */

  const selectedValues = [];

  /*
   * Radio / checkbox style options.
   */
  picker
    .querySelectorAll(
      'input[type="radio"]:checked, ' +
      'input[type="checkbox"]:checked'
    )
    .forEach(input => {

      const value =
        input.value ||
        input.dataset.value ||
        input.getAttribute('data-option-value');

      if (value) {
        selectedValues.push(
          String(value).trim()
        );
      }

    });

  /*
   * Select style options.
   */
  picker
    .querySelectorAll('select')
    .forEach(select => {

      if (select.value) {
        selectedValues.push(
          String(select.value).trim()
        );
      }

    });

  /*
   * Store the selected option values temporarily.
   * The caller can use this when no variant ID exists.
   */
  if (selectedValues.length) {

    picker.__wishlistSelectedValues =
      selectedValues;

  }

  return null;
}

function getWishlistItemByVariant(variantId) {
  const wishlist = getWishlist();

  return wishlist.find(
    item =>
      String(item.variantId) === String(variantId)
  );
}

function getWishlistItemByProduct(productId) {
  const wishlist = getWishlist();

  return wishlist.find(
    item =>
      String(item.id) === String(productId)
  );
}

async function getProductData(handle) {
  if (wishlistProductCache.has(handle)) {
    return wishlistProductCache.get(handle);
  }

  const response = await fetch(`/products/${handle}.js`);

  if (!response.ok) {
    throw new Error('Could not load product data');
  }

  const product = await response.json();

  wishlistProductCache.set(handle, product);

  return product;
}

function ensureWishlistModal() {
  let modal = document.getElementById('aluovi-wishlist-modal');

  if (modal) return modal;

  modal = document.createElement('div');

  modal.id = 'aluovi-wishlist-modal';

  modal.innerHTML = `
  <div class="aluovi-wishlist-overlay"></div>

  <div class="aluovi-wishlist-sheet">

  <div class="aluovi-wishlist-drag-indicator"></div>

  <button
    type="button"
    class="aluovi-wishlist-close"
    aria-label="Close"
  >
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 2L2 12" stroke="currentcolor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M12 12L2 2" stroke="currentcolor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </button>

  <h3 class="aluovi-wishlist-title">
  SAVE TO WISHLIST
</h3>

  <div class="aluovi-wishlist-content">

      <div class="aluovi-wishlist-size-area">

        <button
          type="button"
          class="aluovi-wishlist-size-button"
        >
          <span class="aluovi-wishlist-size-text"></span>

          <svg
  class="aluovi-wishlist-size-arrow"
  xmlns="http://www.w3.org/2000/svg"
  width="12"
  height="12"
  viewBox="0 0 40 40"
  aria-hidden="true"
>
  <path
    fill="#000000"
    d="M4.659 11.833h30.682L20 32.167z"
  />
</svg>
        </button>

        <div class="aluovi-wishlist-size-menu"></div>

        <button
          type="button"
          class="aluovi-wishlist-action"
          disabled
        >
          SELECT SIZE
        </button>

      </div>

    </div>

  </div>
`;

  document.body.appendChild(modal);

  const style = document.createElement('style');

  style.textContent = `
    #aluovi-wishlist-modal {
      position: fixed;
      inset: 0;
      z-index: 10000;
      pointer-events: none;
      visibility: hidden;
    }

    #aluovi-wishlist-modal.is-open {
      pointer-events: auto;
      visibility: visible;
    }

    .aluovi-wishlist-overlay {
      position: absolute;
      inset: 0;
      background: rgba(0,0,0,.5);
      opacity: 0;
      transition: opacity .28s ease;
    }

    #aluovi-wishlist-modal.is-open .aluovi-wishlist-overlay {
      opacity: 1;
    }

    .aluovi-wishlist-sheet {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      background: #fff;
      border-radius: 18px 18px 0 0;
      transform: translateY(100%);
      transition: transform .32s cubic-bezier(.22,.61,.36,1);
      padding: 10px 16px 16px;
      box-sizing: border-box;
      touch-action: none;
    }

    #aluovi-wishlist-modal.is-open .aluovi-wishlist-sheet {
      transform: translateY(0);
    }

    .aluovi-wishlist-drag-indicator {
      width: 42px;
      height: 4px;
      border-radius: 999px;
      background: #d4d4d4;
      margin: 0 auto 18px;
    }

    .aluovi-wishlist-content {
      width: 100%;
    }

    .aluovi-wishlist-title {
      display: none;
    }

     .aluovi-wishlist-close {
      display: none;
    }

    .aluovi-wishlist-size-area {
      position: relative;
      display: flex;
      align-items: stretch;
      gap: 8px;
      width: 100%;
    }

    .aluovi-wishlist-size-button {
      position: relative;
      flex: 0 0 58px;
      width: 58px;
      height: 48px;
      padding: 0;
      border: 1px solid #b5b5b5;
      border-radius: 2px;
      background: #fff;
      color: #111;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 6px;
      font: inherit;
      cursor: pointer;
    }

    .aluovi-wishlist-size-button.is-selected {
      border-color: #111;
    }

    .aluovi-wishlist-size-button.is-sold-out {
      color: #a8a8a8;
    }

    .aluovi-wishlist-size-button.is-locked {
      cursor: default;
      pointer-events: none;
    }

    .aluovi-wishlist-action {
      flex: 1;
      height: 48px;
      border: 1px solid #111;
      border-radius: 2px;
      background: #111;
      color: #fff;
      padding: 0 16px;
      font: inherit;
      font-size: 12px;
      letter-spacing: .08em;
      cursor: pointer;
    }

    .aluovi-wishlist-action:disabled {
      border-color: #b5b5b5;
      background: #fff;
      color: rgba(16,16,16,.3);
      cursor: default;
    }

    .aluovi-wishlist-size-menu {
      position: absolute;
      left: 0;
      bottom: calc(100% + 8px);
      width: 58px;
      max-height: 220px;
      overflow-y: auto;
      background: #fff;
      border: 1px solid #d5d5d5;
      border-radius: 2px;
      box-shadow: 0 10px 30px rgba(0,0,0,.12);
      display: none;
      z-index: 5;
    }

    .aluovi-wishlist-size-menu.is-open {
      display: block;
    }

    .aluovi-wishlist-size-option {
      width: 100%;
      min-height: 42px;
      border: 0;
      background: #fff;
      color: #111;
      padding: 0 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      font: inherit;
      font-size: 13px;
      cursor: pointer;
    }

    .aluovi-wishlist-size-option:hover {
      background: #f6f6f6;
    }

    .aluovi-wishlist-size-option.is-sold-out {
      color: #a8a8a8;
    }

    .aluovi-wishlist-size-option.is-sold-out {
      cursor: default;
    }

    @media (min-width: 750px) {

  .aluovi-wishlist-sheet {
    width: 450px;
    height: 136px;
    left: 50%;
    right: auto;
    top: 50%;
    bottom: auto;
    transform:
      translateX(-50%)
      translateY(100%);
    transition: none;
    border: 1px solid #d7d7d7;
    border-radius: 3px;
    padding: 44px 16px 16px;
    box-shadow:
      0 12px 40px rgba(243, 235, 235, 0.14);
  }

  .aluovi-wishlist-overlay {
    background: rgba(228, 223, 223, 0.6);
  }

  /*
   * Desktop does not need the mobile
   * drag indicator.
   */
  .aluovi-wishlist-drag-indicator {
    display: none;
  }

  /*
   * Desktop close button.
   */
  .aluovi-wishlist-close {
    display: flex;
    position: absolute;
    top: 10px;
    right: 12px;
    width: 18px;
    height: 18px;
    padding: 0;
    border: 0;
    background: transparent;
    color: #767676;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }

  .aluovi-wishlist-close svg {
    display: block;
  }

  .aluovi-wishlist-close:hover {
    opacity: .65;
  }

  #aluovi-wishlist-modal.is-open .aluovi-wishlist-sheet {
    transform:
      translateX(-50%)
      translateY(0);
  }

.aluovi-wishlist-title {
    display: block;
    margin-top: -22px;
    margin-bottom: 20px;
    padding: 0;
    text-align: center;
    font-size: 12px;
    font-weight: 500;
    letter-spacing: .08em;
    line-height: 1;
    color: #111;
  }

    .aluovi-wishlist-content {
    max-width: 400px;
    margin-bottom: 20;
  }

  .aluovi-wishlist-size-button,
  .aluovi-wishlist-action {
    height: 46px;
  }
}
  `;

  document.head.appendChild(style);

  const overlay = modal.querySelector('.aluovi-wishlist-overlay');

overlay.addEventListener('click', () => {
  closeWishlistModal();
});

const closeButton =
  modal.querySelector('.aluovi-wishlist-close');

closeButton.addEventListener('click', () => {
  closeWishlistModal();
});

const sizeButton = modal.querySelector('.aluovi-wishlist-size-button');

  sizeButton.addEventListener('click', () => {

  if (sizeButton.classList.contains('is-locked')) {
    return;
  }

  const sizeMenu =
    modal.querySelector(
      '.aluovi-wishlist-size-menu'
    );

  const arrow =
    modal.querySelector(
      '.aluovi-wishlist-size-arrow'
    );

  const isOpening =
    !sizeMenu.classList.contains('is-open');

  sizeMenu.classList.toggle(
    'is-open',
    isOpening
  );

  /*
   * DOWN ARROW = closed
   * UP ARROW = open
   */
  if (isOpening) {

    arrow.innerHTML = `
      <path
        fill="#000000"
        d="M4.659 28.167h30.682L20 7.833z"
      />
    `;

  } else {

    arrow.innerHTML = `
      <path
        fill="#000000"
        d="M4.659 11.833h30.682L20 32.167z"
      />
    `;

  }

});

  document.addEventListener('click', (event) => {

    const sizeMenu =
      modal.querySelector(
        '.aluovi-wishlist-size-menu'
      );

    if (!sizeMenu) return;

    if (!sizeMenu.classList.contains('is-open')) {
      return;
    }

    const target = event.target;

    if (
      sizeButton.contains(target) ||
      sizeMenu.contains(target)
    ) {
      return;
    }

    sizeMenu.classList.remove('is-open');

    setWishlistSizeArrowDown(modal);

  });

  let startY = 0;
  let currentY = 0;
  let dragging = false;

  const sheet = modal.querySelector('.aluovi-wishlist-sheet');

  sheet.addEventListener('touchstart', (event) => {
    startY = event.touches[0].clientY;
    currentY = startY;
    dragging = true;

    sheet.style.transition = 'none';
  }, { passive: true });

  sheet.addEventListener('touchmove', (event) => {
    if (!dragging) return;

    currentY = event.touches[0].clientY;

    const distance = Math.max(0, currentY - startY);

    sheet.style.transform = `translateY(${distance}px)`;
  }, { passive: true });

  sheet.addEventListener('touchend', () => {
    if (!dragging) return;

    dragging = false;

    const distance = Math.max(0, currentY - startY);

    sheet.style.transition =
      'transform .32s cubic-bezier(.22,.61,.36,1)';

    if (distance > 80) {
      closeWishlistModal();
    } else {
      sheet.style.transform = 'translateY(0)';
    }
  });

  return modal;
}

function resetWishlistModal() {
  const modal = document.getElementById('aluovi-wishlist-modal');

  if (!modal) return;

  const sizeButton =
    modal.querySelector('.aluovi-wishlist-size-button');

  const sizeText =
    modal.querySelector('.aluovi-wishlist-size-text');

  const sizeMenu =
    modal.querySelector('.aluovi-wishlist-size-menu');

  const actionButton =
    modal.querySelector('.aluovi-wishlist-action');

  const wishlistTitle =
    modal.querySelector(
      '.aluovi-wishlist-title'
    );

  sizeButton.classList.remove(
    'is-selected',
    'is-sold-out',
    'is-locked'
  );

  sizeText.textContent = '';

  sizeMenu.innerHTML = '';

  sizeMenu.classList.remove('is-open');

const sizeArrow =
  modal.querySelector(
    '.aluovi-wishlist-size-arrow'
  );

if (sizeArrow) {
  sizeArrow.innerHTML = `
    <path
      fill="#000000"
      d="M4.659 11.833h30.682L20 32.167z"
    />
  `;
}

  actionButton.disabled = true;
  actionButton.textContent = 'SELECT SIZE';

  wishlistTitle.textContent =
    'SAVE TO WISHLIST';
}

function setWishlistSizeArrowDown(modal) {
  const arrow = modal?.querySelector(
    '.aluovi-wishlist-size-arrow'
  );

  if (!arrow) return;

  arrow.innerHTML = `
    <path
      fill="#000000"
      d="M4.659 11.833h30.682L20 32.167z"
    />
  `;
}

function lockWishlistPage() {
  document.documentElement.style.overflow = 'hidden';
  document.body.style.overflow = 'hidden';
}

function unlockWishlistPage() {
  document.documentElement.style.overflow = '';
  document.body.style.overflow = '';
}

function closeWishlistModal() {

  const modal =
    document.getElementById(
      'aluovi-wishlist-modal'
    );

  if (!modal) return;

  const sheet =
    modal.querySelector(
      '.aluovi-wishlist-sheet'
    );

  /*
   * Remove the product-page variant listener
   * while the modal is closed.
   */
  if (
    modal.__wishlistVariantListener
  ) {

    document.removeEventListener(
      'variant:update',
      modal.__wishlistVariantListener
    );

    modal.__wishlistVariantListener =
      null;

  }

  /*
   * Remove the product-page input listener.
   */
  if (
    modal.__wishlistChangeListener
  ) {

    document.removeEventListener(
      'change',
      modal.__wishlistChangeListener
    );

    modal.__wishlistChangeListener =
      null;

  }

  const isDesktop =
  window.matchMedia('(min-width: 750px)').matches;

if (isDesktop) {

  /*
   * DESKTOP:
   * Close immediately.
   * No slide-down animation.
   */
  modal.classList.remove('is-open');

  sheet.style.transition = '';
  sheet.style.transform = '';

  resetWishlistModal();

  unlockWishlistPage();

  return;
}

/*
 * MOBILE:
 * Keep the existing slide-down animation.
 */
sheet.style.transition =
  'transform .32s cubic-bezier(.22,.61,.36,1)';

sheet.style.transform =
  'translateY(100%)';

setTimeout(
  () => {

    modal.classList.remove(
      'is-open'
    );

    sheet.style.transform =
      '';

    resetWishlistModal();

    unlockWishlistPage();

  },
  320
);

}

function getCollectionCard(btn) {

  if (!btn) return null;

  return btn.closest(
    '.product-card, ' +
    '[data-product-card], ' +
    'product-card, ' +
    '.card, ' +
    '.product-item'
  );
}

function getCollectionCardColor(btn) {

  const card = getCollectionCard(btn);

  if (!card) return '';

  /*
   * Look only inside THIS product card.
   */
  const selectedSwatch = card.querySelector(
    '.variant-option--swatches input[type="radio"]:checked'
  );

  if (selectedSwatch) {

    return String(
      selectedSwatch.value ||
      selectedSwatch.dataset.value ||
      selectedSwatch.getAttribute('data-option-value') ||
      ''
    ).trim();

  }

  /*
   * Fallback for swatches that use buttons instead
   * of radio inputs.
   */
  const activeSwatch = card.querySelector(
    '.variant-option--swatches [aria-checked="true"], ' +
    '.variant-option--swatches .is-selected, ' +
    '.variant-option--swatches .selected'
  );

  if (activeSwatch) {

    return String(
      activeSwatch.dataset.value ||
      activeSwatch.getAttribute('data-option-value') ||
      activeSwatch.getAttribute('value') ||
      activeSwatch.textContent ||
      ''
    ).trim();

  }

  return '';
}

async function openWishlistModal(btn) {

  const modal = ensureWishlistModal();

  resetWishlistModal();

  const productId =
    String(btn.dataset.productId || '');

  const handle =
    btn.dataset.productHandle || '';

  const title =
    btn.dataset.productTitle || '';

  const fallbackImage =
  btn.dataset.variantImage ||
  btn.dataset.productImage ||
  '';

  if (!productId || !handle) return;

  /*
   * Open immediately.
   */
  modal.classList.add('is-open');

  lockWishlistPage();

  try {

    const product =
      await getProductData(handle);

    /*
     * --------------------------------------------------
     * PRODUCT VARIANT INFORMATION
     * --------------------------------------------------
     */

    const colorOptionIndex =
  product.options.findIndex(option => {

    const name =
      typeof option === 'string'
        ? option
        : option?.name || '';

    return (
      String(name)
        .trim()
        .toLowerCase() === 'color'
    );

  });

const sizeOptionIndex =
  product.options.findIndex(option => {

    const name =
      typeof option === 'string'
        ? option
        : option?.name || '';

    return (
      String(name)
        .trim()
        .toLowerCase() === 'size'
    );

  });

    /*
     * Get the variant currently selected on the
     * PRODUCT PAGE.
     *
     * This is the important part.
     */
    let currentVariantId =
      getCurrentVariant(btn);

    let currentVariant =
      currentVariantId
        ? product.variants.find(
            variant =>
              String(variant.id) ===
              String(currentVariantId)
          )
        : null;

    /*
     * --------------------------------------------------
     * GET SIZE FROM VARIANT
     * --------------------------------------------------
     */

    const getVariantSize = (variant) => {

      if (!variant) return '';

      if (sizeOptionIndex >= 0) {

        return (
          variant.options?.[sizeOptionIndex] ||
          ''
        );

      }

      return variant.option2 || '';

    };

    /*
     * --------------------------------------------------
     * GET THE CURRENT PRODUCT-PAGE COLOR
     * --------------------------------------------------
     *
     * IMPORTANT:
     *
     * The color comes from the CURRENTLY SELECTED
     * product-page variant.
     *
     * We are NOT choosing a color inside this modal.
     */
 
    const getCurrentColor = () => {

  /*
   * --------------------------------------------------
   * COLLECTION PAGE
   * --------------------------------------------------
   *
   * The wishlist button belongs to a product card.
   * Read the selected swatch from THAT card only.
   */
  const collectionColor =
    getCollectionCardColor(btn);

  if (collectionColor) {
    return collectionColor;
  }

  /*
   * --------------------------------------------------
   * PRODUCT PAGE FALLBACK
   * --------------------------------------------------
   *
   * Keep the existing product-page behavior intact.
   */
  const selectedColorInput =
    document.querySelector(
      '.variant-option--swatches input[type="radio"]:checked'
    );

  if (selectedColorInput) {

    const selectedValue =
      String(
        selectedColorInput.value ||
        selectedColorInput.dataset.value ||
        selectedColorInput.getAttribute('data-option-value') ||
        ''
      ).trim();

    if (selectedValue) {
      return selectedValue;
    }
  }

  /*
   * Final variant fallback.
   */
  const latestVariantId =
    getCurrentVariant(btn);

  if (!latestVariantId) {
    return '';
  }

  const latestVariant =
    product.variants.find(
      variant =>
        String(variant.id) ===
        String(latestVariantId)
    );

  if (
    !latestVariant ||
    colorOptionIndex < 0
  ) {
    return '';
  }

  return String(
    latestVariant.options?.[
      colorOptionIndex
    ] || ''
  ).trim();
};

    /*
     * --------------------------------------------------
     * BUILD THE SIZE MENU FOR THE CURRENT COLOR
     * --------------------------------------------------
     */

    const sizeButton =
      modal.querySelector(
        '.aluovi-wishlist-size-button'
      );

    const sizeText =
      modal.querySelector(
        '.aluovi-wishlist-size-text'
      );

    const sizeMenu =
      modal.querySelector(
        '.aluovi-wishlist-size-menu'
      );

    const actionButton =
      modal.querySelector(
        '.aluovi-wishlist-action'
      );

const wishlistTitle =
  modal.querySelector(
    '.aluovi-wishlist-title'
  );

    let selectedSize = '';

// TEMP DIAGNOSTIC
console.log('===== WISHLIST SIZE DIAGNOSIS =====');

console.log('Product options:', product.options);

console.log('Color option index:', colorOptionIndex);

console.log('Size option index:', sizeOptionIndex);

console.log(
  'Checked color input:',
  document.querySelector(
    '.variant-option--swatches input[type="radio"]:checked'
  )
);

console.log(
  'Checked color value:',
  document.querySelector(
    '.variant-option--swatches input[type="radio"]:checked'
  )?.value
);

console.log(
  'getCurrentVariant(btn):',
  getCurrentVariant(btn)
);

console.log(
  'Product variants:',
  product.variants
);

    function buildWishlistSizes() {

      /*
       * Clear the OLD size list.
       */
      sizeMenu.innerHTML = '';

      /*
       * Close it whenever the color changes.
       */
      sizeMenu.classList.remove(
        'is-open'
      );

      /*
       * Get the CURRENT product-page color.
       */
      const currentColor =
        getCurrentColor();

      /*
       * If there is no detectable color,
       * don't guess a color.
       */
      if (
        !currentColor ||
        colorOptionIndex < 0
      ) {

        sizeText.textContent = '—';

        sizeButton.classList.remove(
          'is-selected',
          'is-sold-out'
        );

        if (!savedItem) {

          actionButton.disabled = true;
          actionButton.textContent =
            'SELECT SIZE';

        }

        return;

      }

      /*
       * ------------------------------------------------
       * THIS IS THE SAME COLOR MATCHING METHOD
       * USED BY YOUR WORKING VIDEO MODAL.
       * ------------------------------------------------
       */

      const variantsForColor =
        product.variants.filter(
          variant => {

            const variantColor =
              String(
                variant.options?.[colorOptionIndex] ||
                ''
              ).trim();

            return (
              variantColor.toLowerCase() ===
              currentColor.toLowerCase()
            );

          }
        );

      /*
       * Build unique sizes.
       */
      const sizes = [];

      variantsForColor.forEach(
        variant => {

          const size =
            getVariantSize(variant);

          if (!size) return;

          /*
           * Don't add the same size twice.
           */
          const existing =
            sizes.find(
              item =>
                String(item.name) ===
                String(size)
            );

          if (existing) return;

          sizes.push({

            name: size,

            variantId:
              variant.id,

            available:
              variant.available

          });

        }
      );

      /*
       * ------------------------------------------------
       * CURRENT SAVED VARIANT
       * ------------------------------------------------
       */

      const latestVariantId =
        getCurrentVariant(btn);

      const latestVariant =
        latestVariantId
          ? product.variants.find(
              variant =>
                String(variant.id) ===
                String(latestVariantId)
            )
          : null;

      /*
 * IMPORTANT:
 * Check whether THIS PRODUCT already has a
 * wishlist variant, regardless of which variant
 * is currently selected on the product page.
 */
const latestSavedItem =
  getWishlistItemByProduct(productId);

      /*
       * ------------------------------------------------
       * SAVED STATE
       * ------------------------------------------------
       */

      if (latestSavedItem) {

wishlistTitle.textContent =
  'REMOVE FROM WISHLIST';

        const savedVariantForCurrentColor =
          product.variants.find(
            variant =>
              String(variant.id) ===
              String(
                latestSavedItem.variantId
              )
          );

        const savedSize =
          savedVariantForCurrentColor
            ? getVariantSize(
                savedVariantForCurrentColor
              )
            : '';

        selectedSize =
          savedSize ||
          latestSavedItem.size ||
          '';

        sizeText.textContent =
          selectedSize || '—';

        sizeButton.classList.add(
          'is-selected',
          'is-locked'
        );

        sizeButton.classList.remove(
          'is-sold-out'
        );

        actionButton.disabled = false;
        actionButton.textContent =
          'REMOVE';

        /*
         * We don't need the size menu when
         * this exact variant is already saved.
         */
        return;

      }

      /*
       * The current color is NOT saved.
       * Unlock the size selector.
       */

wishlistTitle.textContent =
  'SAVE TO WISHLIST';

      sizeButton.classList.remove(
        'is-locked'
      );

           /*
 * ------------------------------------------------
 * INITIAL SIZE DISPLAY
 * ------------------------------------------------
 *
 */

const firstSize =
  sizes.find(size => size.available) ||
  sizes[0];

if (firstSize) {

  /*
   * Display the first available size.
   *
   * This is only the visual/default size.
   * It must NOT be assigned to selectedSize.
   */
  selectedSize = '';

  sizeText.textContent =
    firstSize.name;

  /*
   * Initial state uses the light border.
   */
  sizeButton.classList.remove(
    'is-selected',
    'is-sold-out',
    'is-locked'
  );

  /*
   * SAVE is not available until the customer
   * explicitly chooses a size.
   */
  actionButton.disabled = true;

  actionButton.textContent =
    'SELECT SIZE';

} else {

  selectedSize = '';

  sizeText.textContent =
    '—';

  sizeButton.classList.remove(
    'is-selected',
    'is-sold-out',
    'is-locked'
  );

  actionButton.disabled = true;

  actionButton.textContent =
    'SELECT SIZE';

}

      /*
       * ------------------------------------------------
       * BUILD SIZE DROPDOWN
       * ------------------------------------------------
       */

      sizes.forEach(
        size => {

          const option =
            document.createElement(
              'button'
            );

          option.type =
            'button';

          option.className =
            'aluovi-wishlist-size-option';

          option.textContent =
            size.name;

          if (!size.available) {

            option.classList.add(
              'is-sold-out'
            );

          }

          option.addEventListener(
  'click',
  () => {

    if (!size.available) {
      return;
    }

    selectedSize =
      size.name;

    sizeText.textContent =
      size.name;

    sizeButton.classList.remove(
      'is-sold-out'
    );

    sizeButton.classList.add(
      'is-selected'
    );

    actionButton.disabled =
      false;

    actionButton.textContent =
      'SAVE';

    sizeMenu.classList.remove(
      'is-open'
    );

    /*
     * Keep the DOWN arrow visible after
     * a size has been selected.
     */
    setWishlistSizeArrowDown(modal);

  }
);

          sizeMenu.appendChild(
            option
          );

        }
      );

    }

    /*
     * --------------------------------------------------
     * INITIAL BUILD
     * --------------------------------------------------
     */

    buildWishlistSizes();

    /*
     * --------------------------------------------------
     * REFRESH WHEN THE PRODUCT PAGE VARIANT CHANGES
     * --------------------------------------------------
     */

    const refreshWishlistSizes =
      () => {

        if (
          !modal.classList.contains(
            'is-open'
          )
        ) {
          return;
        }

        buildWishlistSizes();

      };

    /*
     * Shopify/theme variant update event.
     */
    modal.__wishlistVariantUpdate =
      refreshWishlistSizes;

    /*
     * Remove an old listener if this modal
     * is being reused.
     */
    if (
      modal.__wishlistVariantListener
    ) {

      document.removeEventListener(
        'variant:update',
        modal.__wishlistVariantListener
      );

    }

    modal.__wishlistVariantListener =
      refreshWishlistSizes;

    document.addEventListener(
      'variant:update',
      modal.__wishlistVariantListener
    );

    /*
     * Also watch the actual product-page
     * variant inputs/selects.
     *
     * This gives us a second reliable trigger.
     */
    if (
      modal.__wishlistChangeListener
    ) {

      document.removeEventListener(
        'change',
        modal.__wishlistChangeListener
      );

    }

    modal.__wishlistChangeListener =
  (event) => {

    const input =
      event.target.closest(
        'variant-picker input, variant-picker select'
      );

    if (!input) return;

    /*
     * Shopify may need a moment to update
     * the actual variant ID after the color
     * swatch changes.
     *
     * Check several times so the modal always
     * catches the NEW product-page variant.
     */
    let tries = 0;

    const interval =
      setInterval(() => {

        refreshWishlistSizes();

        tries++;

        if (tries >= 8) {
          clearInterval(interval);
        }

      }, 100);

  };

    document.addEventListener(
      'change',
      modal.__wishlistChangeListener
    );

    /*
     * --------------------------------------------------
     * SAVE / REMOVE BUTTON
     * --------------------------------------------------
     */

    actionButton.onclick = async () => {

  /*
   * ------------------------------------------------
   * GET THE COLOR CURRENTLY SELECTED ON THIS
   * COLLECTION PRODUCT CARD
   * ------------------------------------------------
   *
   */

  const currentColor = getCurrentColor();

  if (!currentColor || colorOptionIndex < 0) {
    console.warn(
      'Wishlist SAVE: could not determine collection-card color.'
    );
    return;
  }

  /*
   * ------------------------------------------------
   * FIND VARIANTS FOR THE CURRENT CARD COLOR
   * ------------------------------------------------
   */

  const variantsForCurrentColor =
    product.variants.filter(variant => {

      const variantColor =
        String(
          variant.options?.[colorOptionIndex] || ''
        ).trim();

      return (
        variantColor.toLowerCase() ===
        currentColor.toLowerCase()
      );

    });

  /*
   * ------------------------------------------------
   * REMOVE
   * ------------------------------------------------
   */

  const currentSavedItem =
    getWishlistItemByProduct(productId);

  if (currentSavedItem) {

    let wishlist = getWishlist();

    wishlist = wishlist.filter(
      item =>
        String(item.id) !==
        String(productId)
    );

    saveWishlist(wishlist);

    syncButtons();

    selectedSize = '';

    sizeText.textContent = '';

    sizeButton.classList.remove(
      'is-selected',
      'is-sold-out',
      'is-locked'
    );

    sizeMenu.innerHTML = '';

    sizeMenu.classList.remove('is-open');

    actionButton.disabled = true;
    actionButton.textContent = 'SELECT SIZE';

    buildWishlistSizes();

    setTimeout(() => {
      closeWishlistModal();
    }, 500);

    return;
  }

  /*
   * ------------------------------------------------
   * SAVE
   * ------------------------------------------------
   */

  if (!selectedSize) {
    console.warn(
      'Wishlist SAVE: no size selected.'
    );
    return;
  }

  /*
   * Find the EXACT variant matching:
   *
   * CURRENT CARD COLOR
   * +
   * SELECTED SIZE
   */

  const selectedVariant =
    variantsForCurrentColor.find(
      variant =>
        String(
          getVariantSize(variant)
        ) ===
        String(selectedSize)
    );

  if (!selectedVariant) {

    console.warn(
      'Wishlist SAVE: matching variant not found.',
      {
        currentColor,
        selectedSize,
        variantsForCurrentColor
      }
    );

    return;
  }

  if (!selectedVariant.available) {

    console.warn(
      'Wishlist SAVE: selected variant is unavailable.'
    );

    return;
  }

  /*
   * ------------------------------------------------
   * SAVE THE EXACT VARIANT
   * ------------------------------------------------
   */

  let wishlist = getWishlist();

  /*
   * One wishlist entry per product.
   */

  wishlist = wishlist.filter(
    item =>
      String(item.id) !==
      String(productId)
  );

  /*
 * ------------------------------------------------
 * USE THE IMAGE BELONGING TO THE EXACT VARIANT
 * THAT WAS SELECTED.
 * ------------------------------------------------
 */

const selectedVariantImage =
  selectedVariant.featured_image?.src ||
  selectedVariant.featured_image?.url ||
  fallbackImage ||
  '';

wishlist.push({

  id: productId,

  handle: handle,

  title:
    title ||
    product.title,

  /*
   * IMPORTANT:
   * Save the selected variant's image,
   * not the image originally attached to
   * the wishlist button.
   */
  image:
    selectedVariantImage,

  variantId:
    selectedVariant.id,

  variantTitle:
    selectedVariant.title,

  variantAvailable:
    selectedVariant.available,

  color:
    colorOptionIndex >= 0
      ? selectedVariant.options?.[
          colorOptionIndex
        ] || ''
      : '',

  size:
    sizeOptionIndex >= 0
      ? selectedVariant.options?.[
          sizeOptionIndex
        ] || ''
      : ''

});

  saveWishlist(wishlist);

  syncButtons();

  actionButton.disabled = false;
  actionButton.textContent = 'SAVED';

  setTimeout(() => {
    closeWishlistModal();
  }, 500);

};

  } catch (error) {

    console.error(
      'Wishlist modal failed:',
      error
    );

  }

}

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  // 🧩 Refresh on Shopify section reload or navigation
  document.addEventListener("shopify:section:load", updateCount);
  window.addEventListener("pageshow", init);
  document.addEventListener("vsl:render-wishlist", updateCount);

  // 🔧 Notify other scripts (like the persistent badge)
  function triggerExternalUpdate() {
    window.dispatchEvent(new CustomEvent("wishlist:updated"));
  }

  document.addEventListener("vsl:render-wishlist", triggerExternalUpdate);

document.addEventListener('change', function (e) {
  const input = e.target.closest(
    'variant-picker input, variant-picker select'
  );

  if (!input) return;

  let tries = 0;

  const interval = setInterval(() => {
    syncButtons();
    tries++;

    if (tries > 20) {
      clearInterval(interval);
    }
  }, 120);
});

document.addEventListener('variant:update', function () {

  let tries = 0;

  const interval = setInterval(() => {
    syncButtons();

    tries++;

    if (tries > 12) {
      clearInterval(interval);
    }
  }, 120);
});

/*
 * --------------------------------------------------
 * KEEP PRODUCT-PAGE WISHLIST HEART STATIC
 * --------------------------------------------------
 */

const wishlistHeartObserver =
  new MutationObserver((mutations) => {

    let heartWasRebuilt = false;

    mutations.forEach((mutation) => {

      if (mutation.type !== 'childList') {
        return;
      }

      mutation.addedNodes.forEach((node) => {

        if (node.nodeType !== 1) {
          return;
        }

        /*
         * Check whether Shopify inserted/rebuilt
         * a wishlist heart.
         */
        if (
          node.matches?.(BTN_SELECTOR) ||
          node.querySelector?.(BTN_SELECTOR)
        ) {
          heartWasRebuilt = true;
        }

      });

    });

    if (heartWasRebuilt) {
      syncButtons();
    }

  });

wishlistHeartObserver.observe(
  document.body,
  {
    childList: true,
    subtree: true
  }
);
})();


/* -----------------------------
   WISHLIST PAGE SCRIPT
----------------------------- */

(function(){
  
  function render(){
    var container = document.getElementById('vsl-wishlist-list');
    if (!container) return;

    container.innerHTML = '';

    let list = [];

    try {
      list = JSON.parse(localStorage.getItem('vsl_wishlist_v1') || '[]');
    } catch(e){
      list = [];
    }
   
const box = document.getElementById('wishlist-auth-box');
const text = document.getElementById('wishlist-auth-text');
    
const isLoggedInUser = window.isCustomerLoggedIn === true;
console.log(window.isCustomerLoggedIn);
        
const hasItems = list.length > 0;

if (box && text) {
  if (isLoggedInUser) {
    box.style.setProperty('display', 'none', 'important');
  } else {

    box.style.setProperty('display', 'flex', 'important');

    if (!hasItems) {
      text.innerText =
        "Login to view your wishlist items and access them across all devices";
    } else {
      text.innerText =
        "To save items to your wishlist, please login or sign up";
    }
  }
}
    
    if (!list.length) {
      container.innerHTML = '<p class="wishlist-empty">Your wishlist is empty.</p>';
      return;
    }

    let html = '';

    list.forEach(function(item){
      console.log(item);
      const isSoldOut = item.variantAvailable === false;

      html += `
        <div class="wishlist-item">

          <div class="wishlist-image">
            <img src="${item.image || ''}" alt="${item.title || ''}">
          </div>

          <div class="wishlist-info" style="flex:1">
            <a href="/products/${item.handle || ''}">
              ${item.title || ''}
            </a>

            ${item.variantTitle ? `
              <div class="wishlist-variant" style="font-size:13px;color:#666;margin-top:4px;">
                ${item.variantTitle}
              </div>
            ` : ''}

          </div>      

${isSoldOut ? `

  <span
    data-osf-type="oos"
    data-osf-oos-type="one"
    data-osf-id="${item.id}"
  ></span>

` : `

  <button
    class="wishlist-add"
    data-variant="${item.variantId || ''}"
    style="
      background:#111;
      color:#fff;
      border:none;
      padding:8px 14px;
      cursor:pointer;
    "
  >
    <span class="label">
      Add to Bag
    </span>
  </button>

`}

<div class="remove-wishlist" data-variant="${item.variantId}">
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 1024 1024"><path fill="#222" d="M512 0C229.232 0 0 229.232 0 512c0 282.784 229.232 512 512 512c282.784 0 512-229.216 512-512C1024 229.232 794.784 0 512 0zm0 961.008c-247.024 0-448-201.984-448-449.01c0-247.024 200.976-448 448-448s448 200.977 448 448s-200.976 449.01-448 449.01zm181.008-630.016c-12.496-12.496-32.752-12.496-45.248 0L512 466.752l-135.76-135.76c-12.496-12.496-32.752-12.496-45.264 0c-12.496 12.496-12.496 32.752 0 45.248L466.736 512l-135.76 135.76c-12.496 12.48-12.496 32.769 0 45.249c12.496 12.496 32.752 12.496 45.264 0L512 557.249l135.76 135.76c12.496 12.496 32.752 12.496 45.248 0c12.496-12.48 12.496-32.769 0-45.249L557.248 512l135.76-135.76c12.512-12.512 12.512-32.768 0-45.248z"/></svg>
</div>

        </div>
      `;
    });

    container.innerHTML = html;
    bindWishlistButtons();
    bindWishlistShare();

    if (typeof window.ORDERSIFY_BIS !== 'undefined') {
      window.ORDERSIFY_BIS.collection_products = window.ORDERSIFY_BIS.collection_products || [];

      for (let i = 0; i < list.length; i++) {
        let item = list[i];
        fetch(window.Shopify.routes.root + 'products/' + item.handle + '.js')
          .then(response => response.json())
          .then(product => {
            window.ORDERSIFY_BIS.collection_products.push(product);
            window.ORDERSIFY_BIS.addFlexibleOOSButtons();
          });
      }
    }
  }

  function bindWishlistButtons(){
    const container = document.getElementById('vsl-wishlist-list');
    if (!container) return;

    container.querySelectorAll('.wishlist-add').forEach(function(btn){

      if (btn.dataset.bound === "true") return;
      btn.dataset.bound = "true";

      btn.addEventListener('click', async function(){

        if (btn.disabled) return;

        const variantId = btn.getAttribute('data-variant');
        if (!variantId) return;

        try {

          // 1. Add to cart
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({
              id: variantId,
              quantity: 1
            })
          });

          if (!response.ok) throw new Error('Add failed');

          // 2. Let cart settle
          await new Promise(r => setTimeout(r, 80));

          // 3. Update cart UI
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              data: {
                source: 'wishlist',
                productVariantId: variantId
              }
            }
          }));

          // 4. Open drawer
          document.dispatchEvent(new CustomEvent('cart:open', {
            bubbles: true
          }));

          // 5. Feedback animation
          btn.classList.add('is-added');

btn.querySelector('.label').innerHTML = `
  <svg width="14" height="14" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" class="wishlist-check">
<path d="M4.75439 10.7485L7.68601 14.5888C7.79288 14.7288 7.84632 14.7988 7.91174 14.8242C7.96907 14.8466 8.03262 14.8469 8.09022 14.8253C8.15596 14.8007 8.21026 14.7314 8.31886 14.5927L15.2475 5.74658" stroke="currentColor" stroke-width="var(--icon-stroke-width)" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
  Added
`;

          setTimeout(() => {
  btn.classList.remove('is-added');

  btn.querySelector('.label').innerHTML = `Add to Bag`;
}, 800);

        } catch(err){
          console.error('Wishlist add failed:', err);
        }

      });

    });

container.querySelectorAll('.remove-wishlist').forEach(function(el){

  el.addEventListener('click', function(e){
    e.preventDefault();

    const variantId = el.dataset.variant;

    let list = JSON.parse(localStorage.getItem('vsl_wishlist_v1') || '[]');

    list = list.filter(
    item => String(item.variantId) !== String(variantId)
    );

    localStorage.setItem('vsl_wishlist_v1', JSON.stringify(list));

    document.dispatchEvent(new Event('vsl:render-wishlist'));
  });

});   
  }

function bindWishlistShare() {
  const shareBtn = document.getElementById('wishlist-share-btn');
  if (!shareBtn) return;

  // prevent duplicate listeners
  if (shareBtn.dataset.bound === "true") return;
  shareBtn.dataset.bound = "true";

  shareBtn.addEventListener('click', async function() {
    let list = [];

    try {
      list = JSON.parse(localStorage.getItem('vsl_wishlist_v1') || '[]');
    } catch(e) {}

    if (!list.length) {
      alert('Your wishlist is empty.');
      return;
    }

    // Build product links
    const links = list.map(item =>
      `${window.location.origin}/products/${item.handle}`
    );

    const shareText =
      "My Wishlist:\n\n" + links.join('\n');

    // Mobile native share
    if (navigator.share) {
      try {
        await navigator.share({
          title: 'Here is a link to my wishlist items',
          text: shareText
        });
      } catch(err) {}
      return;
    }

    // Desktop fallback: copy to clipboard
    try {
      await navigator.clipboard.writeText(shareText);
      alert('Wishlist links copied to clipboard.');
    } catch(err) {
      console.error(err);
    }
  });
}

  // INIT
  document.addEventListener('DOMContentLoaded', render);
  document.addEventListener('vsl:render-wishlist', render);
})();